<template>
  <div>
    <p v-if="company == 'Portal'" v-html="$t(portalNoShiptoTranslateId)">
      Please link your account to at least one Ship-To in order to use the MyAirProducts application.
    </p>
    <p v-else v-html="$t('ml_107433', { company: company })">
      Please link your account to at least one Ship-To in order to use the MyAirProducts application.
    </p>
    <p>
      <ap-link :href="`https://account.airproducts.com/shiptos?ReturnUrl=${location}`">{{ $t('ml_104220') }}</ap-link>
    </p>
  </div>
</template>

<script>
import ApLink from '@/components/APLink.vue'

export default {
  name: 'NoShiptos',
  data() {
    return {
      location: window.location.href
    }
  },
  components: {
    ApLink
  },
  props: {
    company: {
      type: String,
      default: 'AirProducts'
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    portalNoShiptoTranslateId() {
      switch (this.user.salesOrg) {
        case "GB46":
          return "ml_133438";
        case "GB47":
          return "ml_133440";
        case "GB49":
          return "ml_133439";
      }
    }
  }
}
</script>
